import styled from 'styled-components';

import React from 'react';
import ButtonLoader from './Loaders/ButtonLoader';

const ButtonStyled = styled.button`
    padding: 0 20px;
    background-color: ${(props) => props.theme.colorButtonPrimary};
    color: ${(props) => props.theme.colorWhite};
    border: none;
    border-radius: 28px;
    cursor: pointer;
    min-height: 47px;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    display:flex;
    align-items:center;
    justify-content:center;

    &:hover {
        background-color: ${(props) => props.theme.colorButtonPrimaryHover};
    }

    &:focus {
        outline: none;
    }
    &:disabled {
        background-color: ${(props) => props.theme.colorButtonPrimaryDisable};
        cursor: not-allowed;
    }
`;

const ButtonLarge = ({ onClick, children, className = '', disabled, loading = false }) => {
    return (
        <ButtonStyled className={className} onClick={onClick} disabled={disabled}>
            {loading ? <ButtonLoader /> : children}
        </ButtonStyled>
    );
};

export default ButtonLarge;
